import React, { Component } from 'react';

export const card = [
    {
      src: "/1.jpg",
      title: "LELO Tiani 3",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/gp/product/B00GM0DXU6/ref=s9_acss_bw_cg_SSGGCOUP_4c1_w?pf_rd_m=ATVPDKIKX0DER&pf_rd_s=merchandised-search-3&pf_rd_r=0ER4TBH50VPR3N8TS1PK&pf_rd_t=101&pf_rd_p=7af2b587-c7bd-42ed-ae4a-42fc501daa29&pf_rd_i=6110399011&th=1",
      description:"For thrill-seeking couples looking for an entirely new way to enjoy sex, TIANI 3 offers powerful, intimate pleasure and guaranteed satisfaction."

    },
    {
      src: "/2.jpg",
      title: "K-Y Couples Pleasure Gel",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/gp/product/B00U2WEJE4/ref=s9_acss_bw_cg_SSGGCOUP_3c1_w?pf_rd_m=ATVPDKIKX0DER&pf_rd_s=merchandised-search-3&pf_rd_r=0ER4TBH50VPR3N8TS1PK&pf_rd_t=101&pf_rd_p=7af2b587-c7bd-42ed-ae4a-42fc501daa29&pf_rd_i=6110399011",
      description:"Created to add a level of excitement to your most passionate activities as a couple, K-Y LOVE Passion is meant to heighten your passion and strengthen your connection with each other. This couples lubricant helps to intensify sensations and enhance the intimate moments you experience together. When it's applied, K-Y LOVE Passion gel produces an enticing sensation you both can feel and delight in together."

    },
    {
      src: "/3.jpg",
      title: "Liberator Wedge",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/Liberator-24-Inch-Wedge-Black-Microfiber/dp/B003P57DDE/ref=lp_6110399011_1_7_s_it?s=hpc&ie=UTF8&qid=1510583864&sr=1-7&th=1",
      description:"The Liberator Wedge is the perfect combination of support and comfort. This patented intimacy cushion features a 27-degree angle to amplify every performance, ease every position and intensify every single sensation.The ergonomic design and flexible versatility will give you more sensitivity and greater stamina for longer sessions that will yield incredible results."

    },
    {
      src: "/4.jpg",
      title: "Silk Rope Bondage Kit",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/Mischief-Polyester-Silk-Rope-Bondage/dp/B002GP5ZE8/ref=lp_6110399011_1_9_s_it?s=hpc&ie=UTF8&qid=1510583864&sr=1-9",
      description:"Experiment with the art of Japanese silk rope bondage with this beginner's rope bondage kit. The kit contains two silky 6-inch polyester ropes for Japanese-style bondage as well as instructions on this sensual bondage art. Knot, twist, tie and bind your lover in new positions that you'll both love. For more variety and advanced bondage positions, get 2 or more kits."

    },
    {
      src: "/5.jpg",
      title: "LELO Oden Remote",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/LELO-Black-Couples-Wireless-Remote/dp/B005HRCLNK/ref=sr_1_49_s_it?s=hpc&ie=UTF8&qid=1510584467&sr=1-49",
      description:"The most luxurious and uniquely designed couple’s ring on the market, the ring itself is a strong material that can be bent back and around, rather than the standard way in which couples’ rings are worn. The remote control is also far more convenient to adjust during intercourse."

    },
    {
      src: "/6.jpg",
      title: "LELO Silk Blindfold",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/dp/B003QIMBI2/ref=twister_B00L8UD71K?_encoding=UTF8&th=1",
      description:"Not seeing where the next touch will come is the perfect prelude to a more satisfying release. lelo's intima silk blindfold allows couples to indulge in the pleasure of mystery, in any situation they chose."

    },
    {
      src: "/7.jpg",
      title: "Tantra Feather Teaser",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/dp/B00413YN2S/ref=twister_B00LBSI51G?_encoding=UTF8&th=1",
      description:"Share the light touch of exquisite pleasure with LELO’s Tantra Feather Teaser, the perfect way to titillate and tease your way to ecstasy. Combining luxurious down feathers with a polished metal and acrylic handle, it offers a stylish invitation to your many soft, sensual, and seductive trysts ahead"

    },
    {
      src: "/8.jpg",
      title: "Massage Candle",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/Massage-Candle-Exotic-Fruits-1oz/dp/B00SUNGXA0/",
      description:"Shunga Erotic Art Massage Candle Exotic Fruits 1oz. 100% natural oils. Produces a lukewarm oil at the touch. Leaves skin soft and silky. Burns for hours. Will not clog pores. This soy based candle can be used both as an ambiance candle and intimate massage oil."

    },
    {
      src: "/9.jpg",
      title: "Kama Sutra Book",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/Little-Black-Book-Kama-Sutra/dp/1593598521/ref=sr_1_8?ie=UTF8&qid=1510587638&sr=8-8&keywords=kama+sutra",
      description:"Adapting ancient wisdom for the modern lover, this ''Classic Guide to Lovemaking'' is the consummate handbook on the ways of passion and desire. From seduction and sensual foreplay to lovemaking positions, this book offers everything you need to know to master the art of love. Let the classic works of erotic literature arouse and uplift you!"

    },
    {
      src: "/10.jpg",
      title: "Prostate Massager",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/LELO-Controlled-Vibrating-Prostate-Massager/dp/B014ANJ5VC/ref=sr_1_10_s_it?s=hpc&ie=UTF8&qid=1510588201&sr=1-10&keywords=lelo&th=1",
      description:"The remote controlled HUGO is perfectly designed to offer entirely new avenues of sexual satisfaction thanks to two intense vibrating. With 8 settings and exclusive Sense Motion technology, HUGO is all set to become the play partner you've been waiting for. USB-rechargeable & 100% waterproof"

    },
    {
      src: "/11.jpg",
      title: "Wand Body Massager",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/LELO-Cordless-Massager-Powerful-Rechargeable/dp/B0081J2BDG/ref=pd_sim_121_14?_encoding=UTF8&pd_rd_i=B008F8J3I4&pd_rd_r=6R72JT5CB7117G55ABBV&pd_rd_w=1rzGp&pd_rd_wg=tI07J&refRID=6R72JT5CB7117G55ABBV&th=1",
      description:"More powerful than any other rechargeable massager on the market today, the large sized SMART WAND is perfect for deeply satisfying all over body massage, relieving tension and relaxing muscles in the back, legs, arms, shoulders and neck. It uses unique SenseTouch technology to let the strenth of vibrations build through contact with the skin, mimicking a real massage. Regular use reduces stress so there's no smarter way to enjoy a luxurious massage and embrace a higher sense of personal well being."

    },
    {
      src: "/12.jpg",
      title: "Couple's Vibrating Ring",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/dp/B006VXXLK6/ref=twister_B076P65X3T?_encoding=UTF8&th=1",
      description:"TOR II is the worlds first waterproof and rechargeable couples ring, boasting 100% more powerful vibrations than any product of its kind! LELOs original TOR was already the premium couples ring on the market, but now LELO's designers have improved performance further still!"

    },
    {
      src: "/13.jpg",
      title: "Sensua Suede Whip",
      likedOne: false,
      likedTwo: false,
      buyLink: "https://www.amazon.com/LELO-Sensua-Suede-Whip-Black/dp/B00413WKBO/ref=sr_1_31_s_it?s=hpc&ie=UTF8&qid=1510589135&sr=1-31&th=1",
      description:"LELO’s Sensua Suede Whip gives you a more daring approach to bedroom intimacy. The soft and supple suede tassels, alongside the polished metal and acrylic handle, make it a stylish addition to any collection - use it to regularly seduce or surprise your partner in all the ways you see fi"

    }
    
  ];


// WEBPACK FOOTER //
// ./src/card.js